import { Box, Card, Flex, Loader, Skeleton } from '@mantine/core';

const DEFAULT_TAB_WIDTHS = [90, 110, 80, 100, 85, 95, 70];
const DEFAULT_ACTION_WIDTHS = [90, 130];

interface DetailsPageLoaderProps {
    tabWidths?: number[];
    actionWidths?: number[];
}

const DetailsPageLoader = ({
    tabWidths = DEFAULT_TAB_WIDTHS,
    actionWidths = DEFAULT_ACTION_WIDTHS,
}: DetailsPageLoaderProps) => {
    return (
        <>
            <Box data-testid="details-page-loader-toolbar" bg="white" px={10} py="sm">
                <Flex align="center" mb={10}>
                    <Skeleton animate={false} height={18} width={200} radius="sm" />
                </Flex>
                <Flex align="center" justify="space-between" px="xs" pb={4}>
                    <Flex gap={6} wrap="wrap">
                        {tabWidths.map((w, i) => (
                            <Skeleton animate={false} key={i} height={32} width={w} radius="xl" />
                        ))}
                    </Flex>
                    <Flex gap={8}>
                        {actionWidths.map((w, i) => (
                            <Skeleton animate={false} key={i} height={32} width={w} radius="sm" />
                        ))}
                    </Flex>
                </Flex>
            </Box>
            <Box
                bg="gray.1"
                px="md"
                pt="md"
                pb={2}
                mih="calc(100vh - 166px)"
                style={{ display: 'flex', flexDirection: 'column' }}
            >
                <Card
                    maw="100%"
                    p="md"
                    radius="md"
                    style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                >
                    <Loader data-testid="details-page-loader-spinner" color="scBlue" />
                </Card>
            </Box>
        </>
    );
};

export default DetailsPageLoader;
